import React, { useRef, useEffect, useState } from 'react';

const Timeline = ({ scheduleData, currentSegment, segments }) => {
  // console.log(scheduleData)
  const [svgWidth, setSvgWidth] = useState(0);
  const containerRef = useRef(null);
  // let data = segments?.map(e => e?.segment_name?.replaceAll(' ', '_'))
  const hours = Array.from({ length: 25 }, (_, i) => i);
  // console.log(hours)
  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setSvgWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const scaleX = (hour) => (Number(hour) / 24) * svgWidth;

  const formatHour = (hour) => {
    if (hour === 0 || hour === 24) return '12';
    if (hour > 12) return (hour - 12).toString();
    return hour.toString();
  };

  const dataKeys = Object.keys(scheduleData).filter(key => (key.endsWith('Start') || key.endsWith('End'))); // Filter for 'In' keys

  return (
    <div className='mt-lg-5' ref={containerRef} style={{ width: '100%', maxWidth: '1100px', margin: '0 auto', overflowX: 'auto' }}>
      <h5 className='text-center pb-0 mb-0'>Scheduled</h5>
      <div>
        <svg width={svgWidth} height="100" preserveAspectRatio="none" style={{ display: 'block', margin: '0 auto' }}>
          <g transform={`translate(0, 0)`}>

            {/* Prep & wrap lines */}
            {dataKeys.map((key, i) => {
              const baseKey = key.replace(/Start|End/, ''); //key.replace('Start', ''); // Get the base key (e.g., 'break1', 'lunch')

              const inTime = parseFloat(scheduleData[`${baseKey}Start`]);
              const outTime = parseFloat(scheduleData[`${baseKey}End`]);
              const color = scheduleData[`${baseKey}Color`];

              // If any of the required data is missing, we can skip this entry
              if (isNaN(inTime) || isNaN(outTime) || !color) return null;

              return (
                <rect
                  key={i}
                  x={scaleX(inTime)}
                  y="30" // Adjust this as necessary
                  width={scaleX(outTime) - scaleX(inTime)}
                  height="20"
                  fill={color}
                />
              );
            })}

            {/* Timeline */}
            <line x1="0" y1="50" x2={svgWidth} y2="50" stroke="#141414" strokeWidth="1" />

            {/* Hour marks and labels */}
            {hours.map(hour => (
              <g key={hour}>
                <line
                  x1={scaleX(hour)}
                  y1="45"
                  x2={scaleX(hour)}
                  y2="55"
                  stroke="#1D6C8B"
                  strokeWidth="1"
                />
                <text
                  x={scaleX(hour)}
                  y="80"
                  textAnchor="middle"
                  fontSize="10"
                  fill="black"
                  dx={hour === 0 ? 5 : hour === 24 ? -4 : 0} // Adjust text position for first and last labels
                >
                  {formatHour(hour)}
                </text>
              </g>
            ))}

            {/* Noon/Midnight labels */}
            <text x="0" y="30" textAnchor="start" fontSize="12" fill="black">midnight</text>
            <text x={scaleX(12)} y="25" textAnchor="middle" fontSize="12" fill="black">noon</text>
            <text x={svgWidth} y="30" textAnchor="end" fontSize="12" fill="black">midnight</text>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Timeline;
